import { render } from "./DashboardGraph.vue?vue&type=template&id=3f40c13c&scoped=true&ts=true"
import script from "./DashboardGraph.vue?vue&type=script&lang=ts"
export * from "./DashboardGraph.vue?vue&type=script&lang=ts"

import "./DashboardGraph.vue?vue&type=style&index=0&id=3f40c13c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f40c13c"]])

export default __exports__